export default __webpack_public_path__ + "static/media/MUANG_THAI_8560.fae7d901.png";